import { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { ProductService } from "../../../services/product";

import { FormattedMessage } from "react-intl";
import { ProductImportJob } from "../../../types/product-import-job";

interface IStep2Props {
  setStep: (step: number) => void;
  job: ProductImportJob;
  setJob: (job: ProductImportJob) => void;
}

function Step2({ setStep, job, setJob }: IStep2Props) {
  const { data: jobStatus, refetch } = useQuery(
    ["productImportJob", job.id],
    () => ProductService.getImportJob(job.id),
    {
      refetchInterval: 1000, // Poll every 1 second
    },
  );

  useEffect(() => {
    if (jobStatus) {
      setJob(jobStatus);
      if (jobStatus.status === "completed" || jobStatus.status === "failed") {
        setStep(3);
      }
    }
  }, [jobStatus, setStep, setJob]);

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner text-center">
        <div className="progress">
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            style={{ width: `100%` }}
          ></div>
        </div>

        <p className="mt-3">
          <FormattedMessage id="Processing file..." />
        </p>
      </div>
    </div>
  );
}

export default Step2;
